import useSWR from "swr";

export const useRecordings = (productionId) => {
    const recordingsKey = productionId ? `/recordings/of-production/${productionId}` : null;
    const { data, error, mutate } = useSWR(recordingsKey);

    return {
        recordings: data,
        isLoading: !error && !data,
        error,
        mutate,
    };
};

export const useAllRecordings = () => {
    const { data, error, mutate } = useSWR('/recordings');

    return {
        recordings: data,
        isLoading: !error && !data,
        error,
        mutate,
    };
};

